import { Currency } from "../../../models/currency/Currency";
import CurrencyConst from "../../consts/CurrencyConst";

const CurrencyUtility = {
    getPrimary(): Currency {
        return CurrencyConst.Euro;
    },
    getSecondary(): Currency {
        return CurrencyConst.Kuna;
    },
    getPrimaryCurrencyById(id: number): Currency {
        if (CurrencyConst.Euro.id === id)
            return CurrencyConst.Euro;
        
        return CurrencyConst.Kuna
    },
    getSecondaryCurrencyById(id: number): Currency {
        if (CurrencyConst.Euro.id !== id)
            return CurrencyConst.Euro;
        
        return CurrencyConst.Kuna
    }
}

export default CurrencyUtility;
